import { isPlatform } from "@ionic/react";
import { enableRemoteConfig } from "../../utils/firebase/RemoteConfig.util";
import {
  APP_UPDATE_ALERT,
  FirebaseRemoteConfiguration,
} from "../../utils/constants";
import { useNetwork } from "../../utils/useNetwork";
import React, { useEffect, useState } from "react";
import { Alert } from "../Alert/Alert";

interface AppUpdateProps {
  getOpenModal?: Function
}

const AppUpdate = ({ getOpenModal }: AppUpdateProps) => {
  const { getNetworkStatus, networkStatus } = useNetwork();
  const [showAppUpdate, setAppUpdate] = useState({
    status: false,
    forceUpdate: false,
    title: "",
    optionalUpdateMessage: "",
    forceUpdateMessage: "",
  });

  useEffect(() => {
    enableRemoteConfig(setAppUpdate);
  }, []);

  const updateApp = async () => {
    getNetworkStatus();
    if (networkStatus.connected === false) {
      getOpenModal && getOpenModal(true);
    } else {
      if (typeof window === "object") {
        let feedbackApp = null;
        if (isPlatform("ios")) {
          feedbackApp = FirebaseRemoteConfiguration.APPLESTORE_REDIRECTURL;
        } else if (isPlatform("android")) {
          feedbackApp = FirebaseRemoteConfiguration.PLAYSTORE_REDIRECTURL;
        }
        feedbackApp && (window.location.href = feedbackApp);
      }
    }
  };

  return (
    <Alert
      isOpen={showAppUpdate.status}
      message={
        showAppUpdate.forceUpdate
          ? showAppUpdate.forceUpdateMessage
          : showAppUpdate.optionalUpdateMessage
      }
      backdropDismiss={false}
      header={showAppUpdate.title}
      cssClass="update-alert"
      mode="md"
      buttons={
        showAppUpdate.forceUpdate
          ? [
              {
                text: APP_UPDATE_ALERT.UPDATE_NOW,
                role: "Ok",
                handler: () => {
                  updateApp();
                  return false;
                },
              },
            ]
          : [
              {
                text: APP_UPDATE_ALERT.UPDATE_NOW,
                role: "Ok",
                handler: () => {
                  updateApp();
                },
              },
              {
                text: APP_UPDATE_ALERT.IGNORE_NOW,
                role: "Cancel",
                handler: () => null,
              },
            ]
      }
    />
  );
};

export default AppUpdate;
